<template>
<modal v-model="inventory" :dir="['right', 'center']" :modalClass="['fill', 'sm']" title="Transacción de Inventario" hideActions>

    <i class="options icon-dots-vertical" slot="options" @click="Options([
        {text: `Eliminar y ${inventory.quantity > 0 ? 'reducir' : 'aumentar'} inventario`, class: 'error-color', function: () => {Delete(true)}, confirm: `¿Eliminar transacción de inventario?`, if: canDelete, icon: 'trash-rollback'},
        {text: 'Eliminar sin afectar inventario', function: () => {Delete(false)}, confirm: `¿Eliminar transacción de inventario?`, if: canDelete, icon: 'trash'},
        {text: 'Imprimir Voucher', function: () => PrintInventoryVoucher(), icon: 'printing'},
    ])"></i>

    <div class="section copyable" v-if="inventory">
        <div class="mb15">
            <div class="bold">Item</div>
            <div>{{inventory.item}}</div>
        </div>
        
        <div class="mb15">
            <div class="bold">Ingresado</div>
            <div>{{Util.Date(inventory.date, 'LLL')}} por {{inventory.custom_data.created_by}}</div>
            <div></div>
        </div>
        
        <div class="mb15" v-if="inventory.custom_data.provider">
            <div class="bold">Proveedor</div>
            <div>{{inventory.custom_data.provider.name}} <span v-if="inventory.custom_data.provider.rut && (inventory.custom_data.provider.has_rut == undefined || inventory.custom_data.provider.has_rut)">- {{ inventory.custom_data.provider.rut }}</span></div>
        </div>
        <div :class="`mb15 ${reference ? 'selectable' : ''} flex align-center`" @click="reference ? reference() : null" v-if="inventory.comment">
            <div class="flex-fill">
                <div class="bold">Comentario</div>
                <div class="flex fill align-center">
                    <div class="flex-fill">{{inventory.comment}}</div>
                    <!--<i v-if="reference" class="icon icon-arrow-right-o c4"></i>-->
                </div>
            </div>
            <button v-if="reference" class="secondary">Ver</button>
        </div>

        <div class="mb15 cred" v-if="inventory.deleted_at">
            <div class="bold">Eliminado</div>
            <div>{{Util.Date(inventory.deleted_at, 'LLL')}}</div>
            <div>{{inventory.custom_data.deleted_by}}</div>
        </div>
        
        <div class="flex mb15">
            <div class="mr20">
                <div class="bold">Cantidad</div>
                <div class="flex align-center">
                    <div><span :class="inventory.quantity < 0 ? 'cred' : 'cgreen'">{{Util.Number(parseFloat(inventory.quantity), false, true)}}</span> <span class="secondary-text ml5" v-if="unit">{{unit}}</span></div>
                    <div class="secondary-text ml10 well mini">{{Util.Number(parseFloat(inventory.quantity_from))}} <span class="secondary-text" v-if="unit">{{unit}}</span> <i class="icon icon-arrow-right ml5 mr5"></i> {{Util.Number(parseFloat(inventory.quantity_to))}} <span class="secondary-text" v-if="unit">{{unit}}</span></div>
                </div>
            </div>

            
        </div>
        

        <div class="flex">

            <div class="mr40" v-if="inventory.money > 0">
                <div class="bold">Total</div>
                <div>{{Util.Price(inventory.money)}}</div>
            </div>

            <div v-if="inventory.unit_cost > 0">
                <div class="bold">Costo Unitario</div>
                <div>${{Util.Number(inventory.unit_cost)}} <span class="secondary-text ml5" v-if="unit">pesos/{{unit}}</span></div>
            </div>

        </div>
        
        <div class="flex mt15" v-if="inventory.custom_data.iva || inventory.custom_data.tax">
            <div class="mr40" v-if="inventory.custom_data.iva">
                <div class="bold">IVA</div>
                <div>{{Util.Price(inventory.custom_data.iva)}}</div>
            </div>
            <div v-if="inventory.custom_data.tax">
                <div class="bold">Impuesto adicional</div>
                <div>{{Util.Price(inventory.custom_data.tax)}}</div>
            </div>
        </div>

        <div class="mt15" v-if="inventory.money > 0">
            <div class="bold">Método de Pago</div>
            <div>{{Util.PayMethod(inventory.pay_method)}}</div>
        </div>
        <div class="mt15" v-if="!inventory.expense_turn">
            <div class="bold cyellow"><i class="icon icon-circle-exclamation mr5"></i> No contabilizado en turno</div>
        </div>
        <input-files v-if="inventory.custom_data.files && inventory.custom_data.files.length" 
        label="Documentos" class="mt15"
        v-model="inventory.custom_data.files" 
        readonly></input-files>

        <div v-if="inventory.custom_data && inventory.custom_data.id_masive" class="mt15 wll">
            <div class="secondary-text">Este movimiento forma parte de una operación con múltiples movimientos</div>
            <button class="secondary mt5" @click="OpenMasiveTransactions">Ver Movimientos Relacionados</button>
        </div>
        <!--<button v-if="inventory.id_transaction" @click="$refs.transactionDetails.Open(inventory.id_transaction)">Ver Transacción</button>-->
    </div>
    <modal v-model="masiveTrasactions" :dir="['right', 'center']" :modalClass="['fill', 'sm']" title="Movimientos Relacionados" hideActions> 
        <i class="options icon-dots-vertical" slot="options" @click="Options([
            {text: 'Imprimir Voucher', function: () => PrintInventoryVoucher(masiveTrasactions)},
        ])"></i>

        <div class="section" v-if="masiveTrasactions && masiveTrasactions.length">
            <div class="mb15">
                <div class="bold">Ingresado</div>
                <div>{{Util.Date(inventory.date, 'LLL')}} por {{inventory.custom_data.created_by}}</div>
            </div>
            <div class="mb15" v-if="inventory.custom_data.provider">
                <div class="bold">Proveedor</div>
                <div>{{inventory.custom_data.provider.name}} <span v-if="inventory.custom_data.provider.rut && (inventory.custom_data.provider.has_rut == undefined || inventory.custom_data.provider.has_rut)">- {{ inventory.custom_data.provider.rut }}</span></div>
            </div>
            <div class="bold mb10">Movimientos relacionados</div>
            <ul>
                <li class="mb5" v-for="transaction in masiveTrasactions" :key="transaction.id">
                    <div class=""><span :class="transaction.quantity < 0 ? 'cred' : 'cgreen'">{{ Util.Number(parseFloat(transaction.quantity), false, true) }}</span> <span class="secondary-text" v-if="units[transaction.item] && units[transaction.item].unit"> {{ units[transaction.item].unit }}</span> {{ transaction.item }}</div>
                    <div class="secondary-text ml10" v-for="value in transaction.comment" :key="value" v-if="Array.isArray(transaction.comment)">{{value}}</div>
                </li>
            </ul>
        </div>
    </modal>
    <transaction-details ref="transactionDetails"></transaction-details>
    <invoice-details ref="invoiceDetails" @OnEditInvoice="$emit('OnEditInvoice', $event)"></invoice-details>

</modal>
</template>
<script>
export default {
    props: {
        units: {
            type: [Object, Array],
            default: null
        }
    },
    data() {
        return {
            inventory: null,
            masiveTrasactions : null
        }
    },
    methods: {
        async Open(inventory) 
        {
            this.masiveTrasactions = null;
            if(typeof inventory == 'number')
            {
                this.Loading();
                try {
                    inventory = (await axios.get(`/inventory/transaction/${inventory}`)).data;    
                    this.Response({error: false});
                } catch (error) {
                    this.Response({error: true, reason: 'DATA_NULL'});
                }
                
            }
            this.inventory = inventory;
        },
        Delete(rollback)
        {
            this.Loading();
            axios.delete(`/inventory/${this.inventory.id}/delete${rollback ? '/rollback' : ''}`).then(res => {
                this.Info('Transacción eliminada');
                this.$emit('OnTransactionDeleted', res.data);
                this.inventory = null;
            }).catch(err => {
                this.Response(err); 
            });
        },
        PrintInventoryVoucher(transaction)
        {
            var data = transaction ? transaction : this.inventory;
            if(!Array.isArray(data)) data = [data];
    
            if(!data) return;

            var moment = require('moment');
            var now = moment();
            var arr = [
                //{text: [this.Local.name, now.format('HH:mm DD/MM')]},
                //{text: `Ingreso: ${data.custom_data.created_by} - ${this.Util.Date(data.date,'HH:mm DD/MM')}`},
                {text: this.Local.name},
                {text: `Fecha impresión: ${now.format('HH:mm DD/MM/YYYY')}`},
                {text: `Fecha movimiento: ${this.Util.Date(data[0].date,'HH:mm DD/MM/YYYY')}`},
                {text: `Ingresado por: ${data[0].custom_data.created_by}`},
            ];

            // if(data.comment) arr.push({text: `Comentario: ${data.comment}`});
            if(data[0].custom_data.provider) arr.push({text: `Proveedor: ${data[0].custom_data.provider.name} ${data[0].custom_data.provider.rut && (data[0].custom_data.provider.has_rut == undefined || data[0].custom_data.provider.has_rut) ?' - '+data[0].custom_data.provider.rut : ''}`});
            arr.push({line: true});

            data.forEach(element => {
                arr.push({text: [`${element.item}`, (element.quantity > 0 ? '+' : '')+this.Util.Number(element.quantity)]});
                arr.push({text: [``, `${this.Util.Number(element.quantity_from)} -> ${this.Util.Number(element.quantity_to)}`]});

                if(element.money)
                {
                    arr.push({line: true});
                    arr.push({text: `Costo unitario: $${this.Util.Number(element.unit_cost)}`});
                    arr.push({text: `Total: ${this.Util.Price(element.money)}`});
                }

                if(data.length > 1) arr.push({line: true});
            });

            // ------ POR ITEM ---- 
            this.Util.NotifyService('print', {data: arr, id: Math.random().toString()});
        },
        OpenMasiveTransactions() {
            if(!this.inventory) return;
            if(this.inventory.custom_data && !this.inventory.custom_data.id_masive) return;
            let idMasive = this.inventory.custom_data.id_masive;
            this.Loading();
            axios.get(`/inventory/${this.Local.id}/masive/${idMasive}`).then(res => {
                this.masiveTrasactions = res.data;
                this.Response("OK");
            }).catch(err => {
                this.Response(err); 
            });
        }
    },
    computed: {
        canDelete() {
            if(!this.inventory) return false;
            if(this.Auth.role.indexOf('admin') == -1) return false;
            if(this.inventory.id_invoice) return false;
            if(this.inventory.deleted_at) return false;
            return true;
            //var moment = require('moment');
            //return this.inventory.date >= moment().unix() - (60*60*24*2);
        },
        unit() {
            if(!this.units || !this.inventory || !this.units[this.inventory.item]) return null;
            return this.units[this.inventory.item].unit;
        },
        reference() {
            if(!this.inventory) return null;
            if(this.inventory.id_transaction) return () => {this.$refs.transactionDetails.Open(this.inventory.id_transaction)};
            if(this.inventory.id_invoice) return () => {this.$refs.invoiceDetails.Open(this.inventory.id_invoice)};
        }
    }
}
</script>